var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import { SNAP_POINT, SNAP_LINE, SNAP_SEGMENT, SNAP_GRID, SNAP_GUIDE, addPointSnap, addLineSnap, addLineSegmentSnap, addGridSnap } from './snap';
import { GeometryUtils } from './export';
import { Map, List } from 'immutable';

export function sceneSnapElements(scene) {
  var snapElements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new List();
  var snapMask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Map();
  var snapSelectedLayer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var width = scene.width,
      height = scene.height;


  var a = void 0,
      b = void 0,
      c = void 0;
  var elements = void 0;

  if (snapSelectedLayer) {
    var selectedLayerID = scene.selectedLayer;
    var layer = scene.layers.get(selectedLayerID);
    elements = snapElements.withMutations(function (snapElements) {
      var lines = layer.lines,
          vertices = layer.vertices,
          pipes = layer.pipes;


      vertices.forEach(function (_ref) {
        var vertexID = _ref.id,
            x = _ref.x,
            y = _ref.y;


        if (snapMask.get(SNAP_POINT)) {
          addPointSnap(snapElements, x, y, 10, 10, vertexID);
        }

        if (snapMask.get(SNAP_LINE)) {
          var _GeometryUtils$horizo = GeometryUtils.horizontalLine(y);

          a = _GeometryUtils$horizo.a;
          b = _GeometryUtils$horizo.b;
          c = _GeometryUtils$horizo.c;

          addLineSnap(snapElements, a, b, c, 10, 1, vertexID);

          var _GeometryUtils$vertic = GeometryUtils.verticalLine(x);

          a = _GeometryUtils$vertic.a;
          b = _GeometryUtils$vertic.b;
          c = _GeometryUtils$vertic.c;

          addLineSnap(snapElements, a, b, c, 10, 1, vertexID);
        }
      });

      if (snapMask.get(SNAP_SEGMENT)) {
        lines.forEach(function (_ref2) {
          var lineID = _ref2.id,
              _ref2$vertices = _slicedToArray(_ref2.vertices, 2),
              v0 = _ref2$vertices[0],
              v1 = _ref2$vertices[1];

          var _vertices$get = vertices.get(v0),
              x1 = _vertices$get.x,
              y1 = _vertices$get.y;

          var _vertices$get2 = vertices.get(v1),
              x2 = _vertices$get2.x,
              y2 = _vertices$get2.y;

          addLineSegmentSnap(snapElements, x1, y1, x2, y2, 20, 1, lineID);
        });

        pipes.forEach(function (_ref3) {
          var pipeID = _ref3.id,
              _ref3$vertices = _slicedToArray(_ref3.vertices, 2),
              v0 = _ref3$vertices[0],
              v1 = _ref3$vertices[1];

          var _vertices$get3 = vertices.get(v0),
              x1 = _vertices$get3.x,
              y1 = _vertices$get3.y;

          var _vertices$get4 = vertices.get(v1),
              x2 = _vertices$get4.x,
              y2 = _vertices$get4.y;

          addLineSegmentSnap(snapElements, x1, y1, x2, y2, 20, 1, pipeID);
        });
      }

      if (snapMask.get(SNAP_GRID)) {
        var divider = 5;
        var gridCellSize = 100 / divider;
        var xCycle = width / gridCellSize;
        var yCycle = height / gridCellSize;

        for (var x = 0; x < xCycle; x++) {
          var xMul = x * gridCellSize;

          for (var y = 0; y < yCycle; y++) {
            var yMul = y * gridCellSize;

            var onXCross = !(x % divider) ? true : false;
            var onYCross = !(y % divider) ? true : false;

            addGridSnap(snapElements, xMul, yMul, 10, onXCross && onYCross ? 15 : 10, null);
          }
        }
      }

      if (snapMask.get(SNAP_GUIDE)) {

        var horizontal = scene.getIn(['guides', 'horizontal']);
        var vertical = scene.getIn(['guides', 'vertical']);

        var hValues = horizontal.valueSeq();
        var vValues = vertical.valueSeq();

        hValues.forEach(function (hVal) {
          vValues.forEach(function (vVal) {
            addPointSnap(snapElements, vVal, hVal, 10, 10);
          });
        });

        hValues.forEach(function (hVal) {
          return addLineSegmentSnap(snapElements, 0, hVal, width, hVal, 20, 1);
        });
        vValues.forEach(function (vVal) {
          return addLineSegmentSnap(snapElements, vVal, 0, vVal, height, 20, 1);
        });
      }
    });
  } else {
    elements = snapElements.withMutations(function (snapElements) {
      scene.layers.forEach(function (layer) {

        // if (snapSelectedLayer && layer.id !== selectedLayer)
        //   continue;

        var lines = layer.lines,
            vertices = layer.vertices,
            pipes = layer.pipes;


        vertices.forEach(function (_ref4) {
          var vertexID = _ref4.id,
              x = _ref4.x,
              y = _ref4.y;


          if (snapMask.get(SNAP_POINT)) {
            addPointSnap(snapElements, x, y, 10, 10, vertexID);
          }

          if (snapMask.get(SNAP_LINE)) {
            var _GeometryUtils$horizo2 = GeometryUtils.horizontalLine(y);

            a = _GeometryUtils$horizo2.a;
            b = _GeometryUtils$horizo2.b;
            c = _GeometryUtils$horizo2.c;

            addLineSnap(snapElements, a, b, c, 10, 1, vertexID);

            var _GeometryUtils$vertic2 = GeometryUtils.verticalLine(x);

            a = _GeometryUtils$vertic2.a;
            b = _GeometryUtils$vertic2.b;
            c = _GeometryUtils$vertic2.c;

            addLineSnap(snapElements, a, b, c, 10, 1, vertexID);
          }
        });

        if (snapMask.get(SNAP_SEGMENT)) {
          lines.forEach(function (_ref5) {
            var lineID = _ref5.id,
                _ref5$vertices = _slicedToArray(_ref5.vertices, 2),
                v0 = _ref5$vertices[0],
                v1 = _ref5$vertices[1];

            var _vertices$get5 = vertices.get(v0),
                x1 = _vertices$get5.x,
                y1 = _vertices$get5.y;

            var _vertices$get6 = vertices.get(v1),
                x2 = _vertices$get6.x,
                y2 = _vertices$get6.y;

            addLineSegmentSnap(snapElements, x1, y1, x2, y2, 20, 1, lineID);
          });

          pipes.forEach(function (_ref6) {
            var pipeID = _ref6.id,
                _ref6$vertices = _slicedToArray(_ref6.vertices, 2),
                v0 = _ref6$vertices[0],
                v1 = _ref6$vertices[1];

            var _vertices$get7 = vertices.get(v0),
                x1 = _vertices$get7.x,
                y1 = _vertices$get7.y;

            var _vertices$get8 = vertices.get(v1),
                x2 = _vertices$get8.x,
                y2 = _vertices$get8.y;

            addLineSegmentSnap(snapElements, x1, y1, x2, y2, 20, 1, pipeID);
          });
        }
      });

      if (snapMask.get(SNAP_GRID)) {
        var divider = 5;
        var gridCellSize = 100 / divider;
        var xCycle = width / gridCellSize;
        var yCycle = height / gridCellSize;

        for (var x = 0; x < xCycle; x++) {
          var xMul = x * gridCellSize;

          for (var y = 0; y < yCycle; y++) {
            var yMul = y * gridCellSize;

            var onXCross = !(x % divider) ? true : false;
            var onYCross = !(y % divider) ? true : false;

            addGridSnap(snapElements, xMul, yMul, 10, onXCross && onYCross ? 15 : 10, null);
          }
        }
      }

      if (snapMask.get(SNAP_GUIDE)) {

        var horizontal = scene.getIn(['guides', 'horizontal']);
        var vertical = scene.getIn(['guides', 'vertical']);

        var hValues = horizontal.valueSeq();
        var vValues = vertical.valueSeq();

        hValues.forEach(function (hVal) {
          vValues.forEach(function (vVal) {
            addPointSnap(snapElements, vVal, hVal, 10, 10);
          });
        });

        hValues.forEach(function (hVal) {
          return addLineSegmentSnap(snapElements, 0, hVal, width, hVal, 20, 1);
        });
        vValues.forEach(function (vVal) {
          return addLineSegmentSnap(snapElements, vVal, 0, vVal, height, 20, 1);
        });
      }
    });
  }

  return elements;
}